import {LinkInput} from '@local/types'
import {Button, SmallText} from '@local/ui/components'
import {cx} from '@local/utils/cx'

export interface FooterListProps {
	className?: string
	title: string
	links: Array<LinkInput | { tag?: string; cta: LinkInput, searchParams?: string }>
	useHash?: boolean
}

export const FooterList = ({className, title, links, useHash = false}: FooterListProps) => {
	return (
		<li className={cx('gutter-pr-1', className)}>
			<SmallText className='pb-12' textColor='grey-1'>{title}</SmallText>
			<ul className='flex flex-col gap-3'>
				{!!links?.length && links.map((link, index) => {
					const linkData = 'cta' in link ? link.cta : link
					const label = 'cta' in link ? link.cta.label : link.label

					return useHash
						? (
							<li key={`chapter-${index}`}>
								<Button className='text-14 text-left normal-case tracking-normal font-[350]' variant='underlined' href='/'>
									{label}
								</Button>
							</li>
						)
						: (
							<li key={`footer-list-${index}`}>
								<Button
									className='text-14 text-left normal-case tracking-normal font-[350]'
									variant='underlined'
									linkInput={'searchParams' in link
										? {
											...linkData,
											query: link.searchParams,
										}
										: linkData}>
									{label}
								</Button>
							</li>
						)
				})}
			</ul>
		</li>
	)
}
